import { useApp } from "@/context/AppContext";

export function About() {
  return (
    <div className="max-w-3xl mx-auto px-4 md:px-8 py-10 md:py-16">
      <div className="overline text-[#E63946] mb-3">About Us</div>
      <h1 className="font-display text-4xl md:text-6xl tracking-tighter mb-8">MODIFY. PERSONALIZE. ELEVATE.</h1>
      <div className="prose prose-invert text-white/80 space-y-5 leading-relaxed">
        <p>Born from a passion for cars and a vision to transform them, <b>Street Auto Accessories</b> brings quality accessories and modification solutions that turn every vehicle into something uniquely yours.</p>
        <p>Based in Mumbai, we serve customers across India — from first-time car owners looking for practical upgrades to enthusiasts building their dream ride. Every product in our catalogue is chosen with care, price transparency and the everyday driver in mind.</p>
        <p>Whether you're personalising a new car, restoring a used one or planning a full modification, we're here to help you find the right accessory for your drive.</p>
      </div>
    </div>
  );
}

export function Contact() {
  const { settings } = useApp();
  const s = settings || {};
  const email = (s.email || "StreetAutoMumbai@gmail.com").replace(/@google\.com$/i, "@gmail.com");
  const whatsapp = s.whatsapp || "8879874738";
  return (
    <div className="max-w-3xl mx-auto px-4 md:px-8 py-10 md:py-16" data-testid="contact-page">
      <div className="overline text-[#E63946] mb-3">Contact</div>
      <h1 className="font-display text-4xl md:text-6xl tracking-tighter mb-8">GET IN TOUCH</h1>
      <div className="space-y-4 text-lg">
        <div><span className="overline text-white/50 block">Phone</span>{s.phone || "8879874738"}</div>
        <div><span className="overline text-white/50 block">WhatsApp</span><a href={`https://wa.me/91${whatsapp}`} target="_blank" rel="noreferrer" className="text-[#E63946]">{whatsapp}</a></div>
        <div><span className="overline text-white/50 block">Email</span>{email}</div>
        <div><span className="overline text-white/50 block">Address</span>{s.address || "Mumbai, India"}</div>
        <div><span className="overline text-white/50 block">Instagram</span>{s.instagram || "@StreetAutoAccessories"}</div>
      </div>
    </div>
  );
}
